import { Box, Typography } from "@mui/material";
import { useState } from "react";
import TimeFilter from "../../components/filters/TimeFilter";

const mockTimeOptions = [
  { name: "1h", label: "Last 1 hour", displayName: "Last 1 hour" },
  { name: "24h", label: "Last 24 hours", displayName: "Last 24 hours" },
  { name: "7d", label: "Last 7 days", displayName: "Last 7 days" },
  { name: "30d", label: "Last 30 days", displayName: "Last 30 days" },
];

const LOGIC_OR = "OR";

const TimeFilterDemo = () => {
  const [appliedFilters, setAppliedFilters] = useState({ lastSeen: {} });
  const [filterLogic, setFilterLogic] = useState({ lastSeen: LOGIC_OR });

  // Get selected value (single select)
  const selected = Object.keys(appliedFilters.lastSeen || {}).find(
    (k) => appliedFilters.lastSeen[k]
  );

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="subtitle1">
        TimeFilter Example (Last Seen)
      </Typography>
      <TimeFilter
        filterName="Last Seen"
        fieldName="lastSeen"
        options={mockTimeOptions}
        appliedFilters={appliedFilters}
        setAppliedFilters={setAppliedFilters}
        filterLogic={filterLogic.lastSeen}
        setFilterLogic={(logic) =>
          setFilterLogic({ ...filterLogic, lastSeen: logic })
        }
      />
      <Typography variant="body2">
        Selected:{" "}
        {selected
          ? mockTimeOptions.find((opt) => opt.name === selected)?.label
          : "None"}{" "}
        | Logic: {filterLogic.lastSeen}
      </Typography>
    </Box>
  );
};

export default TimeFilterDemo;
